import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigator } from './components/navigator';
import { Home } from './landingpage/home';
import { WhyLearning } from './docs/whylearning';
import { ToastContainer } from './chatbot/components/toastcontainer';
import { Founder } from './docs/founder';
import ScrollToHash from './scroll';
import { BuildingAgents } from './docs/buildingagents';
import { DialogContainer } from './dialogs/dialogcontainer';
import { AuthorizeDialog } from './dialogs/authorizedialog';
import { Users } from './fasades/users';
import { IState } from './chatbot/api/llmapi';
import { Spinner } from './chatbot/components/spinner';
import { SpinnerManager } from './fasades/spinnermanager';
import { NotFound } from './docs/notfound';
import Layout, { Display } from './chatbot/components/Layout/Layout';
import { ApiReference } from './apiref/apireference';
import { ApiRef } from './fasades/apiref';
import './styles.css';
import { PaymentSuccess } from './landingpage/paysuccess';
import { PaymentCancel } from './landingpage/paycancel';
import { Investors } from './landingpage/investors';
import { Pricing } from './docs/pricing';
import { Privacy } from './docs/privacy';
import { Terms } from './docs/terms';

interface State {
    state       : IState;
    stateLoaded : boolean;
    showSpinner : boolean;
}

export class App extends React.Component<{}, State> {

    constructor(props: {})
    {
        super(props);
        this.state = {
            state       : { playgroundRunning : false },
            stateLoaded : false,
            showSpinner : false
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (token) {
            AuthorizeDialog.showChangePasswordDilog(token);
        }

        Users.onUpdate((state : IState) => { this.setState({ stateLoaded : true, state }) } );
        Users.getState();
        SpinnerManager.onUpdate(this.enableDisableSpinner.bind(this));
    }

    componentWillUnmount()
    {
        SpinnerManager.removeUpdateEvent(this.enableDisableSpinner.bind(this));
    }

    enableDisableSpinner(busy : boolean)
    {
        this.setState({showSpinner : busy});
    }

    render() {
        return (
            <div className="main-page">
                <BrowserRouter>
                    <ScrollToHash />
                    <Navigator state={ this.state.state }>
                        {{
                            desc : "Home",
                            to   : "/"
                        }}
                        {{
                            desc : "API Reference",
                            children : [
                                {
                                    desc : "Overview",
                                    to   : "/apiref"
                                },
                                {
                                    desc : "Streaming Guide",
                                    to   : "/apiref/streaming"
                                },
                                ...ApiRef.getAllEndpoints().map(endpoint => ({
                                    desc : endpoint.title,
                                    to   : `/apiref/${endpoint.docurl}`
                                }))
                            ]
                        }}
                        {{
                            desc : "Docs",
                            children : [ {
                                    desc : "About the founder",
                                    to   : "/docs/founder"
                                },
                                {
                                    desc : "Building Agents",
                                    to   : "/docs/buildingagents"
                                },
                                {
                                    desc : "Why Learning",
                                    to   : "/docs/whylearning"
                                },
                                {
                                    desc : "Pricing",
                                    to   : "/docs/pricing"
                                },
                                {
                                    desc : "Terms and Conditions",
                                    to   : "/docs/terms"
                                },
                                {
                                    desc : "Privacy Policy",
                                    to   : "/docs/privacy"
                                }
                            ]
                        }}
                        {{
                            desc : "Playground",
                            to   : "/playground"
                        }}
                        {{
                            desc : "Investors",
                            to   : "/investors"
                        }}
                    </Navigator>
                    <Routes>
                        <Route path="/" element={<Home state={ this.state.state }/>} />
                        <Route path="/playground"            element={<Layout state={ this.state.state } stateLoaded={ this.state.stateLoaded} display={ Display.Conversation } />} />
                        <Route path="/playground/apikeys"    element={<Layout state={ this.state.state } stateLoaded={ this.state.stateLoaded} display={ Display.APIKeys } />} />
                        <Route path="/playground/chats"      element={<Layout state={ this.state.state } stateLoaded={ this.state.stateLoaded} display={ Display.Chats } />} />
                        <Route path="/playground/models"     element={<Layout state={ this.state.state } stateLoaded={ this.state.stateLoaded} display={ Display.Models } />} />
                        <Route path="/playground/billing"     element={<Layout state={ this.state.state } stateLoaded={ this.state.stateLoaded} display={ Display.Billing } />}/>
                        <Route path="/apiref/generate-response" element={<ApiReference doc={ ApiRef.getEndpoint('generate-response') }/>} />
                        <Route path="/apiref/list-models"    element={<ApiReference doc={ ApiRef.getEndpoint('list-models') }/>} />
                        <Route path="/apiref/create-model"   element={<ApiReference doc={ ApiRef.getEndpoint('create-model') }/>} />
                        <Route path="/apiref/delete-model"   element={<ApiReference doc={ ApiRef.getEndpoint('delete-model') }/>} />
                        <Route path="/apiref/train"          element={<ApiReference doc={ ApiRef.getEndpoint('train') }/>} />
                        <Route path="/apiref/streaming"      element={<ApiReference streaming={true}/>} />
                        <Route path="/apiref"                element={<ApiReference/>} />
                        <Route path="/docs/buildingagents"   element={<BuildingAgents/>} />
                        <Route path="/docs/founder" element={<Founder/>} />
                        <Route path="/docs/whylearning" element={<WhyLearning/>}/>
                        <Route path="/docs/pricing" element={<Pricing/>} />
                        <Route path="/docs/privacy" element={<Privacy/>} />
                        <Route path="/docs/terms" element={<Terms/>} />
                        <Route path="/investors" element={<Investors/>}/>
                        <Route path="/pay/success" element={<PaymentSuccess/>}/>
                        <Route path="/pay/cancel" element={<PaymentCancel/>}/>
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
                <DialogContainer />
                <ToastContainer/>
                { this.state.showSpinner && <Spinner /> }
            </div>
        );
    }
}
